export enum AddendumDescriptionType {
  SuperFund = 'SUPER_FUND',
  TransactionHistory = 'TRANSACTION_HISTORY',
}
export interface AddendumItem {
  term: string;
  description: string | AddendumDescriptionType;
  source: string;
}
